import { calenderIcon } from "../../tabs/StoreSearchTab";
import "./dropDown.css";
import React, { useState, useRef, useEffect } from "react";
const Dropdown = ({ options, selectedValue, onSelect, placeholder = "Select option", className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className={`custom-dropdown ${className}`} ref={dropdownRef}>
      <div style={{ color: "#0e49b5", marginLeft: "8px" }} className={`dropdown-trigger ${isOpen ? "dropdown-trigger-open" : ""}`} onClick={handleToggle}>
        <span>{calenderIcon}</span>
        <span style={{ color: "#0e49b5" }} className='dropdown-value'>
          {selectedValue || placeholder}
        </span>
        <svg
          style={{ color: "#0e49b5" }}
          className={`dropdown-arrow ${isOpen ? "dropdown-arrow-rotated" : ""}`}
          width='12'
          height='8'
          viewBox='0 0 12 8'
          fill='none'
        >
          <path d='M1 1.5L6 6.5L11 1.5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>

      {isOpen && (
        <div className='dropdown-menu'>
          <div className='dropdown-menu-content'>
            {options.map((option, index) => (
              <div
                key={`${option}-${index}`}
                className={`dropdown-option ${selectedValue === option ? "dropdown-option-selected" : ""}`}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const DropdownFilter = ({ onYearChange, onMonthChange, defaultYear = "2025", defaultMonth = "June" }) => {
  const [selectedYear, setSelectedYear] = useState(defaultYear);
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);

  // get this year as a number
  const currentYear = new Date().getFullYear();

  // build an array of strings ["2025", "2024", …, "2021"]
  const years = [];
  for (let y = currentYear; y >= 2021; y--) {
    years.push(String(y));
  }

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const handleYearSelect = (year) => {
    setSelectedYear(year);
    if (onYearChange) {
      onYearChange(year);
    }
  };

  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
    if (onMonthChange) {
      onMonthChange(month);
    }
  };

  return (
    <div className='dropdown-filter-container'>
      <div className='dropdown-filter-wrapper'>
        <Dropdown options={years} selectedValue={selectedYear} onSelect={handleYearSelect} placeholder='Select Year' className='year-dropdown' />
        <Dropdown options={months} selectedValue={selectedMonth} onSelect={handleMonthSelect} placeholder='Select Month' className='month-dropdow' />
      </div>
    </div>
  );
};

export default DropdownFilter;
